const SDD_ORDER_DETAILS = 'sddOrderDetailsSection';
const STANDARD_SHIPPING_ORDER_DETAILS = 'standardShippingOrderDetailsSection';
const SEE_CURBSIDE_CONCIERGE_LOCATION_LINK = 'curbsideConciergeOrderConfirmationBccContent';

export {
    SDD_ORDER_DETAILS, STANDARD_SHIPPING_ORDER_DETAILS, SEE_CURBSIDE_CONCIERGE_LOCATION_LINK
};
